// Tipo de comercio (FC_TIPO_EMPRESA): 1 Restaurante, 2 Comercial, 4 TapOnPhone, 5 Supermercados

export const COMPANY_TYPE_RESTAURANT = 1;
export const COMPANY_TYPE_TAP_ON_PHONE = 4;
export const COMPANY_TYPE_SUPERMARKET = 5;

type WithCompanyType = { companyTypeId?: number | string } | null | undefined;

export const isRestaurantMerchant = (merchant: WithCompanyType) =>
    Number(merchant?.companyTypeId) === COMPANY_TYPE_RESTAURANT;

export const isTapOnPhoneMerchant = (merchant: WithCompanyType) =>
    Number(merchant?.companyTypeId) === COMPANY_TYPE_TAP_ON_PHONE;

// Ejemplos para las promociones por horario según el tipo de comercio
export const scheduleExamples = (merchant: WithCompanyType) => {
    switch (Number(merchant?.companyTypeId)) {
        case COMPANY_TYPE_RESTAURANT:
            return {
                name: 'Happy hour',
                description: 'Happy hour y menú del día',
                example: '"Happy hour" con 50 % en cervezas de lunes a viernes de 17:00 a 19:00',
            };
        case COMPANY_TYPE_SUPERMARKET:
            return {
                name: 'Martes de frutas',
                description: 'Martes de frutas y verduras, pan del día a mitad de precio en la noche',
                example: '"Martes de frutas" con 20 % en frutas y verduras todos los martes',
            };
        default:
            return {
                name: 'Viernes de descuento',
                description: 'Viernes de descuento u hora loca',
                example: '"Viernes de descuento" con 15 % en productos seleccionados todos los viernes',
            };
    }
};
